import { render, staticRenderFns } from "./trainingList.vue?vue&type=template&id=5c90b5bc&scoped=true&"
import script from "./trainingList.vue?vue&type=script&lang=js&"
export * from "./trainingList.vue?vue&type=script&lang=js&"
import style0 from "./trainingList.vue?vue&type=style&index=0&id=5c90b5bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c90b5bc",
  null
  
)

export default component.exports